import { Box, Grid } from "@mui/material";
import styles from "../ConfirmationWithPayment.module.css";
import ConfirmationDetailCard from "../../../../../Shared/ConfirmationDetailCard";
import { CalendarDays, Gift, IdCardLanyard, LocateFixed, UserRound, UsersRound } from "lucide-react";
import { selectBooking, selectBookingType, setNotes } from "../../../../bookingSlice";
import { BookingStatus } from "../../../../bookingSlice.types";
import ConfirmationNotesCard from "../../../../../Shared/ConfirmationNotesCard";
import { useSessionBookingData } from "../../useSessionBookingData";
import { useClientPortalDispatch, useClientPortalSelector } from "../../../../../../redux";
import { AppointmentBookingClientModel } from "types/generated/models";
import ConfirmationAppointmentForCard from "../../ConfirmationAppointmentForCard";
import { BookingType } from "types/appointmentBooking";
import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";
import { getGroupBookingLabel } from "../../../../../../utils/groupBookingLabel";

export interface ConfirmationDetailsWithPaymentProps {
    shouldShowContactsDropdown: boolean;
    relatedClients: AppointmentBookingClientModel[];
    bookedSuccessfully: boolean;
}

export default function ConfirmationDetailsWithPayment({
    shouldShowContactsDropdown,
    relatedClients,
    bookedSuccessfully,
}: ConfirmationDetailsWithPaymentProps) {
    const {
        locationContent,
        serviceNameContent,
        groupContent,
        providerContent,
        whenContent,
        whenTimeZoneContent,
        clientContent,
    } = useSessionBookingData();
    const bookingType = useClientPortalSelector(selectBookingType);
    const { session, confirmation } = useClientPortalSelector(selectBooking);
    const dispatch = useClientPortalDispatch();
    const {
        clientPortalConfig: { groupBookingLabel },
    } = useClientPortalConfigContext();
    const configuredGroupBookingLabel = getGroupBookingLabel(groupBookingLabel);

    const isBookingCompleted = session.bookingStatus === BookingStatus.BOOKED;
    const completedData = session.completedBookingData;

    const notes =
        isBookingCompleted && completedData ? completedData.confirmation?.notes || "" : confirmation.data?.notes || "";

    const handleNotesChange = (newNotes: string) => {
        dispatch(setNotes(newNotes));
    };
    return (
        <Grid
            sx={{ width: "100%" }}
            data-test-id="section_confirmation_details_with_payment"
            size={{
                xs: 12,
                md: 6,
            }}
        >
            <Box className={styles.leftColumn}>
                <ConfirmationDetailCard title="Location" content={locationContent} icon={LocateFixed} />
                <ConfirmationDetailCard title="Provider" content={providerContent} icon={IdCardLanyard} />
                {bookingType === BookingType.CLIENT && (
                    <ConfirmationDetailCard title="Service" content={serviceNameContent} icon={UserRound} />
                )}
                {bookingType === BookingType.CLASS && (
                    <ConfirmationDetailCard
                        title={configuredGroupBookingLabel}
                        content={groupContent}
                        icon={UsersRound}
                    />
                )}
                <ConfirmationDetailCard
                    title="When"
                    content={whenContent}
                    contentSuffix={whenTimeZoneContent}
                    icon={CalendarDays}
                />
                {shouldShowContactsDropdown &&
                    (bookedSuccessfully ? (
                        <ConfirmationDetailCard title="Appointment for:" content={clientContent} icon={Gift} />
                    ) : (
                        <ConfirmationAppointmentForCard relatedClients={relatedClients} />
                    ))}
                <ConfirmationNotesCard
                    notes={notes}
                    isBookingCompleted={isBookingCompleted}
                    onNotesChange={handleNotesChange}
                />
            </Box>
        </Grid>
    );
}
